import { onMessageFromWebApp, sendMessageToWebApp } from "./webAppMessenger";
import {
  USER_LOCATION_WATCH,
  USER_LOCATION_WATCH_ERROR,
  USER_LOCATION_WATCH_CLEAR,
  USER_LOCATION_UPDATE,
  USER_LOCATION_GET,
  USER_LOCATION_GET_ERROR,
  USER_LOCATION_GET_SUCCESS
} from "./messageTypes";

const defaultOptions = {
  enableHighAccuracy: true,
  timeout: 30000,
  maximumAge: 100
};

let watcher = null;

if (navigator.geolocation) {
  onMessageFromWebApp(USER_LOCATION_WATCH, options => {
    console.log("onMessageFromWebApp", USER_LOCATION_WATCH);
    if (!watcher) {
      watcher = navigator.geolocation.watchPosition(
        position => {
          sendMessageToWebApp(USER_LOCATION_UPDATE, {
            coords: {
              accuracy: position.coords.accuracy,
              altitude: position.coords.altitude,
              altitudeAccuracy: position.coords.altitudeAccuracy,
              heading: position.coords.heading,
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
              speed: position.coords.speed
            }
          });
        },
        error => {
          let reason = `Couldn't get user location. Reason: ${error.message} Error Code: ${error.code}`;
          sendMessageToWebApp(USER_LOCATION_WATCH_ERROR, { error: reason });
        },
        options || defaultOptions
      );
    }
  });

  onMessageFromWebApp(USER_LOCATION_WATCH_CLEAR, () => {
    if (watcher) {
      navigator.geolocation.clearWatch(watcher);
      watcher = null;
    }
  });

  onMessageFromWebApp(USER_LOCATION_GET, ({ options }) => {
    navigator.geolocation.getCurrentPosition(
      position => {
        sendMessageToWebApp(USER_LOCATION_GET_SUCCESS, {
          coords: {
            accuracy: position.coords.accuracy,
            altitude: position.coords.altitude,
            altitudeAccuracy: position.coords.altitudeAccuracy,
            heading: position.coords.heading,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            speed: position.coords.speed
          }
        });
      },
      error => {
        let reason = `Couldn't get user location. Reason: ${error.message} Error Code: ${error.code}`;
        sendMessageToWebApp(USER_LOCATION_GET_ERROR, { error: reason });
      },
      options || defaultOptions
    );
  });
}
